/** Whether study metadata opts into the in-app experience */
export const studyMetadataOptsIntoNativeDcr = (studyMetadata) => studyMetadata?.dcrNativeExperienceEnabled === true;
/** Whether a study configuration opts into the in-app experience */
export const studyConfigOptsIntoNativeDcr = (studyConfig) => studyMetadataOptsIntoNativeDcr(studyConfig?.versions?.[0]?.configuration?.studyMetadata);
